import React, { Component, PropTypes } from 'react';
import styles from 'components/Course/TableOfContents/styles';
import { Units } from 'Css';

const css = oxygenCss({
  root: {
    lineHeight: '26px',
    fontSize: '20px',
    padding: Units.base
  },
  section: {
    padding: `0 0 ${Units.base * 2}px 0`
  },
  sectionHeader: {
    letterSpacing: '0.5px',
    padding: `${Units.base / 2}px 0`
  },
  pageHeader: {
    letterSpacing: '0.1px',
    padding: `${Units.base / 2}px 0`
  }
});

class CourseTableOfContents extends Component {
  static propTypes = {
    toc: PropTypes.array
  };

  render() {
    const { toc } = this.props;
    return (
      <div className={css.root}>
        {toc.map(section => {
          if(section.name.match(/(^|\s)Quiz(\s|$)/g)) {
            return null
          }
          return (
            <div key={section.id} className={css.section}>
              <div className={css.sectionHeader}>{section.name}</div>
              {section.pages.map(page => {
                return (
                  <div className={css.pageHeader} key={page.id}>
                    {page.name}
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
    );
  }
}

export default CourseTableOfContents;



// WEBPACK FOOTER //
// ./src/js/components/Store/CourseTableOfContents.js